import {
    componentClasses,
    componentName,
} from "../../../core/components/input-password/input-password";
import { defaultProps, schema } from "../../../core/components/input-password/input-password";
import { actions, createStore, reducers, renderState } from "../../../core/js/state-machine";
import validateInitialization from "../../../core/js/helpers/validate-initialization";

const views = Object.freeze({
    show: {
        attrs: { "aria-hidden": "false", type: "text" },
    },
    hide: {
        attrs: { "aria-hidden": "true", type: "password" },
    },
    valid: {
        attrs: { "aria-invalid": "false" },
        classList: [`!${componentClasses.validated}`],
    },
    invalid: {
        attrs: { "aria-invalid": "true" },
        classList: [`${componentClasses.validated}`],
    },
});

const validateHTML = (element) => {
    const switchButton = element.querySelector(`.${componentClasses.switchButton}`);
    const passwordInput = element.querySelector(`.${componentClasses.passwordInput}`);
    return !!switchButton && !!passwordInput ? { switchButton, passwordInput } : false;
};

const InputPassword = (element, props = {}) => {
    const [success, mergedProps, validElements] = validateInitialization({
        componentName,
        element,
        defaultProps,
        props,
        schema,
        validateHTML,
    });
    if (!success) return;

    const handleStateChange = (hiddenState) => {
        renderState(hiddenState ? views.hide : views.show, validElements.passwordInput);
        if (hiddenState) {
            validElements.switchButton.setAttribute("title", mergedProps.srHideTitle);
            validElements.switchButton.innerText = mergedProps.showLabel;
        } else {
            validElements.switchButton.setAttribute("title", mergedProps.srShowTitle);
            validElements.switchButton.innerText = mergedProps.hideLabel;
        }
    };

    // Const validate = (isValid) => {
    //     if (!isValid) {
    //         if (!element.classList.contains(componentClasses.validated)) {
    //             renderState(views.invalid, element);
    //             validElements.passwordInput.insertAdjacentHTML(
    //                 "afterend",
    //                 alertNotice({ class: componentClasses.errorIcon })
    //             );
    //         }
    //     } else {
    //         renderState(views.valid, element);
    //     }
    // };

    // handle show/hide button click

    const toggle = () => {
        passwordInputStore.dispatch(actions.toggle());
    };

    const show = () => {
        passwordInputStore.dispatch(actions.show());
    };

    const hide = () => {
        passwordInputStore.dispatch(actions.hide());
    };

    const dispose = () => {
        element[componentName] = null;
        element = null;
        validElements.switchButton.removeEventListener("click", toggle);
    };

    //Initializing the store
    const initialState = true;
    const passwordInputStore = createStore(reducers.boolReducer, initialState);

    passwordInputStore.subscribe(handleStateChange);

    // Add event listeners
    validElements.switchButton.addEventListener("click", toggle);

    const api = {
        element,
        //Validate,
        dispose,
        show,
        hide,
    };

    element[componentName] = api;
    // Return ourselves incase we are captured in js.
    return api;
};

export default InputPassword;
